/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

@Injectable()
export class ThemeService {
  private themeMap: { [key: string]: () => Promise<any> } = {
    blue: () => import('@gh/theme/styles/theme-blue.scss'),
    red: () => import('@gh/theme/styles/theme-red.scss'),
    green: () => import('@gh/theme/styles/theme-green.scss'),
    purple: () => import('@gh/theme/styles/theme-purple.scss'),
  };

  use(name: string): void {
    const list = document.body.classList;
    // remove current theme
    for (let i = 0; i < list.length; i++) {
      const className = list.item(i)!;
      if (/mat-theme$/.test(className)) {
        list.remove(className);
        i--;
      }
    }

    // assign new theme
    list.add(`${name}-mat-theme`);
  }

  load(name: string): Promise<void> {
    const themeLoader = this.themeMap[name];
    if (!themeLoader) {
      return Promise.reject(new Error(`Theme '${name}' not found. Available themes: ${Object.keys(this.themeMap).join(', ')}`));
    }
    return themeLoader().then(() => void 0);
  }
}
